// @ts-nocheck
import { createTheme } from "@mui/material/styles"

export default createTheme({
	breakpoints: {
		values: {
			zero: 0,
			min: 320,
			xs1: 385,
			xs2: 450,
			sm1: 600,
			sm2: 750,
			md1: 900,
			md2: 1050,
			lg: 1200,
			xl: 1600
		}
	},

	components: {
		 MuiOutlinedInput:{
			styleOverrides: {
					root: {
					'& input[type=number]': {
						'-moz-appearance': 'textfield', // For Firefox
						'-webkit-appearance': 'none', // For Chrome, Safari, Edge, Opera
						margin: 0, // Remove margin in Safari
					},
					'& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
						'-webkit-appearance': 'none',
					},
					},
			}
		 },
		 MuiTextField: {
			styleOverrides: {
					root: {
					'& input[type=number]': {
						'-moz-appearance': 'textfield', // For Firefox
						'-webkit-appearance': 'none', // For Chrome, Safari, Edge, Opera
						margin: 0, // Remove margin in Safari
					},
					'& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
						'-webkit-appearance': 'none',
					},
					},
			}
		},
		MuiTypography: {
			styleOverrides: {
				root: {
					color: "#465578"
				}
			}
		},

		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: "10px"
				}
			}
		}
	},

	typography: {
		button: {
			textTransform: "none"
		}
	}
})
